// This controller is inert outside the dedicated Moonlit Sea product section.
(() => {
  const mount = (scope) => scope.querySelectorAll('[data-moonlit-product-section]').forEach((section) => {
    if (section.moonlitOptions) return;
    const data = section.querySelector('[data-moonlit-variants]');
    const select = section.querySelector('[data-moonlit-native-select]');
    if (!data || !select) return;
    const variants = JSON.parse(data.textContent);
    const choices = [...section.querySelectorAll('[data-purchase-choice]')];
    if (!variants.length) return;
    const price = section.querySelector('[data-current-price]');
    const compare = section.querySelector('[data-compare-price]');
    const status = section.querySelector('[data-moonlit-selection-status]');
    const add = section.querySelector('button[name="add"]');
    const express = section.querySelector('[data-buy-now]');
    const expressLabel = express?.querySelector('[data-buy-now-label]') || express;
    const paymentTermsContainer = section.querySelector('[data-moonlit-payment-terms]');
    const form = select.closest('form');
    let current;

    const byId = (id) => variants.find((variant) => variant.id === String(id));
    function showMedia(variant, animate) {
      const slides = [...section.querySelectorAll('[data-product-gallery-slide]')];
      const index = variant ? slides.findIndex((slide) => variant.mediaId && slide.dataset.mediaId === String(variant.mediaId)) : 0;
      if (index >= 0) section.moonlitGallery?.goTo(index, animate ? 'smooth' : 'auto');
    }
    function apply(id, historyMode = 'none') {
      const variant = byId(id);
      const changed = current?.id !== variant?.id;
      current = variant;
      choices.forEach((choice) => { choice.checked = choice.value === variant?.id; });
      select.value = variant?.id || '';
      const paymentTerms = section.querySelector('shopify-payment-terms');
      if (paymentTerms && variant) paymentTerms.setAttribute('variant-id', variant.id);
      if (paymentTermsContainer) paymentTermsContainer.hidden = !variant;
      price.textContent = variant?.priceDisplay || section.dataset.unselectedPrice;
      if (compare) {
        compare.textContent = variant?.compareDisplay || '';
        compare.hidden = !variant?.compareDisplay;
      }
      if (add) {
        add.disabled = !variant?.available;
        add.textContent = !variant ? section.dataset.chooseLabel : variant.available ? section.dataset.addLabel : section.dataset.soldLabel;
        add.dataset.defaultLabel = add.textContent;
        add.dataset.sku = variant?.sku || '';
        add.dataset.variantId = variant?.id || '';
      }
      if (express) {
        express.disabled = !variant?.available;
        expressLabel.textContent = !variant || variant.available ? express.dataset.defaultLabel : section.dataset.soldLabel;
        express.dataset.variantId = variant?.id || '';
      }
      if (status) status.textContent = variant ? [variant.label, variant.priceDisplay].join('. ') : section.dataset.chooseLabel;
      if (variant) section.dataset.selectedVariant = variant.id;
      else delete section.dataset.selectedVariant;
      if (historyMode !== 'none' && (changed || historyMode === 'replace')) {
        const url = new URL(location.href);
        if (variant) url.searchParams.set('variant', variant.id);
        else url.searchParams.delete('variant');
        history[historyMode === 'replace' ? 'replaceState' : 'pushState']({ ...(history.state || {}), moonlitVariant: variant?.id || null }, '', url);
      }
      showMedia(variant, historyMode === 'push');
      section.dispatchEvent(new CustomEvent('moonlit:variant-change', { detail: variant ? { ...variant } : null }));
    }
    choices.forEach((choice) => {
      choice.addEventListener('change', () => apply(choice.value, 'push'));
      choice.addEventListener('click', () => {
        if (choice.value === current?.id) showMedia(current, true);
      });
    });
    select.addEventListener('change', () => apply(select.value, 'push'));
    form.addEventListener('submit', (event) => {
      if (current) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      choices[0]?.focus();
    }, true);
    const productPath = location.pathname;
    const popstate = () => { if (section.isConnected && location.pathname === productPath) apply(new URL(location.href).searchParams.get('variant')); };
    addEventListener('popstate', popstate);
    const dispose = section.miaDispose;
    section.miaDispose = () => { dispose?.(); removeEventListener('popstate', popstate); };
    section.addEventListener('moonlit:gallery-ready', () => showMedia(current, false));
    section.moonlitOptions = { select: (id) => apply(id, 'push'), current: () => current ? { ...current } : null };
    const urlId = new URL(location.href).searchParams.get('variant');
    apply(urlId, urlId && !byId(urlId) ? 'replace' : 'none');
  });
  mount(document);
  document.addEventListener('mia:page:mount', event => mount(event.detail.root));
})();
